import { Plus } from "lucide-react";
import { useEffect, useState } from "react";
import { Button } from "../../../design/components/Button.js";
import { api, type Conference, type ReviewAssignmentWorkspace } from "../../api.js";
import { AddReviewersSheet } from "./AddReviewersSheet.js";
import { AssignmentsView } from "./AssignmentsView.js";
import { ReviewerPool } from "./ReviewerPool.js";
import { ReviewProgressView } from "./ReviewProgressView.js";

type Tab = "reviewers" | "assignments" | "reviews" | "settings";
const tabs: Array<{ key: Tab; label: string }> = [{ key: "reviewers", label: "Reviewers" }, { key: "assignments", label: "Assignments" }, { key: "reviews", label: "Reviews" }, { key: "settings", label: "Settings" }];

export function ReviewWorkspace({ conference }: { conference: Conference }) {
  const [tab, setTab] = useState<Tab>("reviewers");
  const [addOpen, setAddOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [workspace, setWorkspace] = useState<ReviewAssignmentWorkspace | null>(null);

  useEffect(() => {
    let active = true;
    api.reviewAssignmentWorkspace(conference.id, conference.organization_id)
      .then((value) => { if (active) setWorkspace(value); })
      .catch(() => undefined);
    return () => { active = false; };
  }, [conference.id, conference.organization_id, refreshKey]);

  return <section className="review-workspace">
    <header><div><h1>Review</h1><p>Recruit people, assign work deliberately, and follow completion without mixing those jobs together.</p></div>{tab === "reviewers" ? <Button onClick={() => setAddOpen(true)}><Plus size={16} />Add reviewers</Button> : null}</header>
    <div role="tablist" aria-label="Review workspace">{tabs.map((item) => <button key={item.key} type="button" role="tab" aria-selected={tab === item.key} onClick={() => setTab(item.key)}>{item.label}</button>)}</div>
    <div role="tabpanel">
      {tab === "reviewers" ? <ReviewerPool conference={conference} refreshKey={refreshKey} /> : null}
      {tab === "assignments" ? <AssignmentsView conference={conference} onWorkspace={setWorkspace} /> : null}
      {tab === "reviews" ? <ReviewProgressView workspace={workspace} /> : null}
      {tab === "settings" ? <section className="review-settings"><h2>Review rounds</h2>{workspace?.review_rounds.length ? workspace.review_rounds.map((round) => <article key={round.id}><strong>{round.name}</strong><span>{round.status}</span></article>) : <p>Open Assignments once to load the configured review rounds.</p>}</section> : null}
    </div>
    <AddReviewersSheet open={addOpen} conference={conference} onClose={() => setAddOpen(false)} onCompleted={() => setRefreshKey((value) => value + 1)} />
  </section>;
}
